import styled from "styled-components";
import { CenterFlexColumn, FlexRow } from "styles/layout";

export const OrgLogoContainer = styled.div`
  width: 42px;
  height: 42px;

  @media (max-width: 700px) {
    width: 32px;
    height: 32px;
  }
`;

export const BracketRoundHeader = styled.div`
  background: seagreen;
  filter: grayscale(0.4);
  color: white;
  width: 100%;
  text-align: center;
  height: 20px;
  margin-bottom: 5px;
  font-size: 11pt;
`;

export const MatchTeamContainer = styled(FlexRow)`
  padding: 2px;
  border: 1px solid black;
  width: 155px;
  height: 25px;

  &:last-child {
    border-top: none;
  }
`;

export const MatchPointsContainer = styled(CenterFlexColumn)`
  width: 25px;
  height: 100%;
  border: 1px solid black;
  border-left: none;
  box-sizing: border-box;
`;

export const BracketLogoContainer = styled.div<{ selected: boolean }>`
  width: 22px;
  height: 22px;
  padding-right: 4px;
  ${({ selected }) => !selected && "opacity: 0.5"}
`;

export const OrgName = styled.span<{ selected: boolean }>`
  font-size: 11pt;
  font-weight: 600;
  ${({ selected }) => !selected && "opacity: 0.5; font-weight: normal"}
`;
